import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <div className="hero">
      <div className="container hero__container">
        <div className="hero__content">
          <h1 className="hero__title">
            <small>Try anime</small>
            <span>tattoos on your body</span>
          </h1>
          <div className="hero__info">
            Upload your photo.<br />
            Try Naruto, One Piece, Hunter x Hunter tattoos instantly.
          </div>
        </div>
        <div className="hero__img">
          <img src="/img/model_w_tattoo.png" alt="Anime tattoo try-on" />
        </div>
      </div>
    </div>
  );
};

export default Hero;
